import logo from "../../../images/MyYerevanLogo.png";
import location_marker from "../../../images/location_marker.png";
import surface from "../../../images/surface.png";
import stairs from "../../../images/stairs.png";
import room from "../../../images/room.png";
import bathroom from "../../../images/bathroom.png";
import btype from "../../../images/btype.png";
import { useState } from "react";
import "./componentscss.css";

export default function StyleForAllPartsMy({
    el,
    estateId,
    setEstateOn,
    id,
    deleteRealEstate,
    handleDelete,
    recoverRealEstate,
})
{   
    const changeintoArmenian = (str) => {
      if (str === "Center") return "ԿԵՆՏՐՈՆ";
      if (str === "Arabkir") return "ԱՐԱԲԿԻՐ";
      if (str === "Davtashen") return "ԴԱՎԹԱՇԵՆ";
      if (str === "Ajapnyak") return "ԱՋԱՓՆՅԱԿ";
      if (str === "Vahagni-district") return "ՎԱՀԱԳՆԻ ԹԱՂԱՄԱՍ";
      if (str === "Kanaker-Zeytun") return "ՔԱՆԱՔԵՌ-ԶԵՅԹՈՒՆ";
      if (str === "Avan") return "ԱՎԱՆ";
      if (str === "Nor-Norq") return "ՆՈՐ-ՆՈՐՔ";
      if (str === "Nork-Marash") return "ՆՈՐՔ-ՄԱՐԱՇ";
      if (str === "Shengavit") return "ՇԵՆԳԱՎԻԹ";
      if (str === "Malatia-Sebastia") return "ՄԱԼԱԹԻԱ-ՍԵԲԱՍՏԻԱ";
      if (str === "Erebuni") return "ԷՐԵԲՈՒՆԻ";
      if (str === "Jrvej") return "ՋՐՎԵԺ";
      if (str === "Dzoraghpyur") return "ՁՈՐԱՂԲՅՈՒՐ";
      if (str === "Zovuni") return "ԶՈՎՈՒՆԻ";
      if (str === "Ptghni") return "ՊՏՂՆԻ";
      if (str === "Qasakh") return "ՔԱՍԱԽ";
      if (str === "Nor-Geghi") return "ՆՈՐ ԳԵՂԻ";
      if (str === "Nor-Hajn") return "ՆՈՐ ՀԱՃՆ";
      if (str === "Tsakhkadzor") return "ԾԱՂԿԱՁՈՐ";
      if (str === "Abovyan") return "ԱԲՈՎՅԱՆ";
      if (str === "Proshyan") return "ՊՌՈՇՅԱՆ";
      if (str === "Arinj") return "ԱՌԻՆՋ";
      if (str === "Byureghavan") return "ԲՅՈՒՐԵՂԱՎԱՆ";
      if (str === "Yeghvard") return "ԵՂՎԱՐԴ";
      if (str === "Dilijan") return "ԴԻԼԻՋԱՆ";
  };
	const [imageIndex, setImageIndex] = useState(0);
	const [touchStart, setTouchStart] = useState(null);
  const [isSmall] = useState(window.innerWidth <= 800);
  const [copied, setCopied] = useState(false);
  const [hoveredId, setHoveredId] = useState(null);
  const version = el?.ubdate_date ? new Date(el?.ubdate_date).getTime() : Date.now();
const shareurl = `https://my-yerevan.am/${estateId}/0?v=${version}`;

const handleClick = () => {
  navigator.clipboard.writeText(shareurl);
  setCopied(true);
};
	const nextimage = () => {
  setImageIndex((prev) =>
    prev === el.urls.length - 1 ? 0 : prev + 1
  );
};

const previmage = () => {
  setImageIndex((prev) =>
    prev === 0 ? el.urls.length - 1 : prev - 1
  );
};
	const nextImage = (e) => {
     e.stopPropagation();

     setImageIndex((prev) => (prev === el.urls.length - 1 ? 0 : prev + 1));
   };

   const prevImage = (e) => {
     e.stopPropagation();

     setImageIndex((prev) => (prev === 0 ? el.urls.length - 1 : prev - 1));
   };

	const handleTouchStart = (e) => {
    setTouchStart(e.touches[0].clientX);
  };

  const handleTouchEnd = (e) => {
    if (!touchStart) return;

    const touchEnd = e.changedTouches[0].clientX;
    const distance = touchStart - touchEnd;

    if (distance > 50) {
      nextimage(); // свайп влево
    }

    if (distance < -50) {
      previmage(); // свайп вправо
    }

    setTouchStart(null);
  };
    return (
      <div className="housesInfo" key={estateId}>
        <div
	    style={{position:"relative"}} 
	    className="brokerHouses">
          {el.urls?.length > 1 && !isSmall && (
            <>
              <button
                onClick={prevImage}
                style={{
			border: "none",
                  position: "absolute",
                  left: "10px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  zIndex: 2,
                }}
              >
                ◀
              </button>

              <button
                onClick={nextImage}
                style={{
			border: "none",
                  position: "absolute",
                  right: "10px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  zIndex: 2,
                }}
              >
                ▶
              </button>
            </>
          )}
	    <img
	    onTouchStart={handleTouchStart}
            onTouchEnd={handleTouchEnd}
            style={{ cursor: "pointer" }}
            onClick={() => {
              setEstateOn(true);
              window.open(`/${id}/${estateId}`, "_blank");
            }}
            src={el.urls?.length > 0 ? el.urls[imageIndex] : logo}
            alt=""

          />
	    {el.is_sold === true && <p style = {{color:"red", fontWeight:"bold", fontSize:25}}>ՎԱՃԱՌՎԱԾ Է</p>}
          <div className="divideb">
            <button
              style={{ cursor: "pointer" }}
              onClick={() => {
                //navigate(`/${id}/add`, { state: { data: el } });
                window.open(`/${id}/${estateId}/add`, "_blank");
              }}
            >
              ՓՈՓՈԽԵԼ
            </button>
            {el.deleted !== true && (
  <button
    style={{ cursor: "pointer" }}
    onClick={() => {
      if (window.confirm("Իսկապե՞ս ցանկանում եք ջնջել")) {
        deleteRealEstate(estateId);
        handleDelete(el, estateId);
      }
    }}
  >
    ՋՆՋԵԼ
  </button>
)}
{el.deleted === true && (
  <button
    style={{ cursor: "pointer" }}
    onClick={() => {
      if (window.confirm("Իսկապե՞ս ցանկանում եք վերականգնել")) {
        recoverRealEstate(estateId);
      }
    }}
  >
    ՎԵՐԱԿԱՆԳՆԵԼ
  </button>
)}
            <button
              onClick={handleClick}
              style={{
                backgroundColor: copied ? "gray" : "green",
                color: "white",
                padding: "10px 20px",
                border: "none",
                cursor: "pointer",
              }}
            >
              ՊԱՏՃԵՆԵԼ
            </button>
          </div>
        </div>
        <div className="upanddownn">
          <div className="parametrs">
            <p className="elId">ID:{estateId}</p>
            {el.estate_type !== "land" && (
              <p className="saleOrRent">
                {el.sale_rent === "Sale" && "ՎԱՃԱՌՔ"}{" "}
                {el.sale_rent === "Rent" && "ՎԱՐՁԱԿԱԼՈՒԹՅՈՒՆ"}
              </p>
            )}
            {el.estate_type === "land" && <p className="saleOrRent">ՎԱՃԱՌՔ</p>}
            <p
              className={
                el.status === "regular" ? "status_regular" : "status_exclusive"
              }
            >
              {el.status === "regular" && <span>ՌԵԳՈՒԼՅԱՐ</span>}
                {el.status === "exclusive" && <span>ԷՔՍԿԼՅՈՒԶԻՎ</span>}
                {el.status === "document_exclusive" && (
                  <span>ՊԱՅՄԱՆԱԳՐՈՎ ԷՔՍԿԼՅՈՒԶԻՎ</span>
                )}
            </p>
            <p
              className={
                el.aplication_status === "active"
                  ? "aplication_status_active"
                  : "aplication_status_passive"
              }
            >
              {el.aplication_status === "active" && <span>ԱԿՏԻՎ</span>}
                {el.aplication_status === "passive" && <span>ՊԱՍԻՎ</span>}
                {el.aplication_status === "archive" && <span>ԱՌԽԻՎ</span>}
            </p>
	    {el.deleted && <p style={{borderRadius:12,backgroundColor:"red", color: "white", fontWeight:"bold"}}>ՋՆՋՎԱԾ</p>}
          </div>
          <p className="elName">{el.estate_name}</p>
          <p className="location">
            <img src={location_marker} alt="" />
            ԵՐԵՎԱՆ, {changeintoArmenian(el.district)}, {el.street}
            {"  "}
            {el.house_number && `${el.house_number} տ․`}
            {el.building_number && `${el.building_number} շ․`}
            {el.land_number},{el.room_number && `${el.room_number} բն․`}
          </p>
          <div className="parametrs">
            <span>
              <img className="icon" src={surface} alt="" /> {el.surface}
              Մ²
            </span>
            {el.estate_type !== "land" && (
              <span>
                <img className="icon" src={stairs} alt="" />
                {el.estate_type === "house"
                  ? el.building_floor
                  : `${
                      el.estate_type === "apartment" ? el.a_floor : el.c_floor
                    }/${el.building_floor}`}
              </span>
            )}
            {el.estate_type !== "land" && (
              <span>
                <img className="icon" src={room} alt="" /> {el.rooms}
              </span>
            )}
            {el.estate_type !== "land" && (
              <span>
                <img className="icon" src={bathroom} alt="" />
                {el.bathroom}
              </span>
            )}
          </div>
          <div className="bts">
            {el.estate_type !== "land" && (
              <span>
                <img className="icon" src={btype} alt="" />
                {el.buildingtype === "Panel" && "ՊԱՆԵԼԱՅԻՆ"}
                {el.buildingtype === "Stone" && "ՔԱՐԵ"}
                {el.buildingtype === "Monolith" && "ՄՈՆՈԼԻՏ"}
                {el.buildingtype === "Other" && "ԱՅԼ"}
              </span>
            )}
            {el.new_status === "on" && <span style={{color:"#143356"}}>*ՆՈՐԱԿԱՌՈՒՅՑ*</span>}
          </div>
        </div>
        {!isSmall && (
          <div className="elPriceDiv">
		<p className="elPrice">
  			{el.price !== -1 ? `${el.price}$` : "ԳԻՆԸ ՊԱՅՄԱՆ."}
		</p>
            <div className="sqr">
              {el.price !== -1 && el.sale_rent !== "Rent" && (
                <span className="green">
                  {Math.round(el.price / el.surface)}$/Մ²
                </span>
              )}
            </div>
		{el.percent !== 0 && <p className="percent">{el.percent}%</p>}
            {el.rent_end_date && <p>{el.rent_end_date}</p>}		
          </div>
        )}
        <div className="upanddown">
          {isSmall && (
            <div className="elPriceDiv">
              <p className="elPrice">
  {el.price !== -1 ? `${el.price}$` : "ԳԻՆԸ ՊԱՅՄԱՆ."}
</p>
              <div className="sqr">
                {el.price !== -1 && el.sale_rent !== "Rent" && (
                  <span className="green">
                    {Math.round(el.price / el.surface)}$/Մ²
                  </span>
                )}
              </div>
	      {el.percent !== 0 && <p className="percent">{el.percent}%</p>}
	      {el.rent_end_date && <p>{el.rent_end_date}</p>}
            </div>
          )}
          <div className="info">
            <div className="divide">
              <p>ԳՈՐԾԱԿԱԼ</p>
              <p >
                {el.broker_name} {el.broker_surname}
              </p>
            </div>
            <div className="divide">
              <p>ՄԵՆԵՋԵՐ</p>
              <p >
                {el.manager_name} {el.manager_surname}
              </p>
            </div>
          </div>
          <div className="info">
            <div className="divide">
              <p>ՏԵՂԱԴՐՎԵԼ Է</p>
              <p >
                {new Date(el.create_date).toLocaleString("en-US", {
                  day: "2-digit",
                  month: "short",
                  year: "numeric",
                  hour: "2-digit",
                  minute: "2-digit",
                  hour12: false,
                })}
              </p>
            </div>
            <div className="divide">
              <p>ԹԱՐՄԱՑՎԵԼ Է</p>
              <p >
                {new Date(el.ubdate_date).toLocaleString("en-US", {
                  day: "2-digit",
                  month: "short",
                  year: "numeric",
                  hour: "2-digit",
                  minute: "2-digit",
                  hour12: false,
                })}
              </p>
            </div>
          </div>
          <div className="info">
            <div className="divide">
              <p>ԳՈՒՅՔԻ ՏԵՐ</p>
              <p >{el.owner_name}</p>
            </div>
            <div
              className="divide"
              onMouseEnter={() => setHoveredId(estateId)}
              onMouseLeave={() => setHoveredId(null)}
              style={{ position: "relative" }}
            >
              <p>ՏԻՐՈՋ ՀԱՄԱՐԸ</p>
              {hoveredId !== estateId && (
                <p style={{ cursor: "pointer" }} >
                  {el.owner_number[0]}
                </p>
              )}

              {hoveredId === estateId && (
                <div
                  style={{
                    position: "absolute",
                    top: "30px",
                    left: "0",
                    backgroundColor: "rgb(211, 211, 211)",
                    width: "172px",
                    borderRadius: "15px",
                  }}
                >
                  {el.owner_number?.map((num, index) => (
                    <p className="green" key={index + 1}>
                      {num}
                    </p>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
};

